import { module } from 'angular';

import { DetailedView, DomainTree, SkillView, SyntheticView } from './';
import { default as hypervisionServiceName, HypervisionService } from './hypervision.service';

export default module('contact.hypervision', [DetailedView, DomainTree, SkillView, SyntheticView]).service(
  hypervisionServiceName,
  HypervisionService
).name;
